declare const window: {
  dataLayer: any[];
};

/* If you add new ones here. Remeber to add them in Google Tag Manager GA4 Event Tag */
type validEvents =
  | "on_cookie_consent"
  | "on_company_contact"
  | "on_facebook_carousel_clicked"
  | "on_shared_with_friend"
  | "on_content_task_feedback"
  | "on_newsletter_subscribe"
  | "on_external_link_clicked"
  | "on_questionnaire_submitted"
  | "on_one_tap"
  | "on_kpi"
  | "on_impression"
  | "lead_generated";

/* If you add new ones here. Remeber to add them in Google Tag Manager GA4 Event Tag, And in CustomDefinitions IN GA4 */
type validParameters =
  | "in_section"
  | "action"
  | "href"
  | "variant"
  | "lead_type"
  | "customer_id"
  | "customer_name"
  | "user_data"
  | "item_id"
  | "item_category"
  | "item_type";

type validUserData = "email" | "phone" | "zip" | "city" | "country";

export function trackGaEvent(
  type: validEvents,
  parameters?: { [key in validParameters]?: string | number },
  userData?: { [key in validUserData]?: string | number },
  callback?: (id: string) => void
) {
  window.dataLayer = window.dataLayer || [];
  //convert parameter keys to dlv_* for Tag Manager.
  const convertedParams = convertParams(parameters);

  const event: any = {
    event: type,
    ...convertedParams,
  };

  if (userData) {
    event.user_data = userData;
  }

  if (callback) {
    event.eventCallback = callback;
  }

  window.dataLayer.push(event);
}

/* If you add new ones here. Remeber to add them in Google Tag Manager GA4 DLV */
type validDataLayerVariables = "page_type" | "category";

export function setDataLayerVariables(parameters: {
  [key in validDataLayerVariables]?: string | number;
}) {
  window.dataLayer = window.dataLayer || [];
  //convert parameter keys to dlv_* for Tag Manager.
  const convertedParams = convertParams(parameters);
  window.dataLayer.push({
    ...convertedParams,
  });
}

function convertParams(parameters?: { [key: string]: string | number }) {
  return parameters
    ? Object.fromEntries(
        Object.entries(parameters).map(([key, value]) => [`dlv_${key}`, value])
      )
    : {};
}

export function trackVirtualPageView(url: string) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "GAVirtualPageView",
    virtualPageUrl: url,
  });
}
